import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";



// const hideLoader = () => {
//   const loader = document.getElementById("preloader");
//   const root = document.getElementById("root");

//   if (loader) loader.style.display = "none";
//   if (root) root.style.display = "block";
//   if (loader) {
//     loader.classList.add("fade-out");
//     setTimeout(() => loader.remove(), 400);
//   }
// };

// hideLoader();



const MIN_LOADER_TIME = 2000; // 2 seconds branding time
const startTime = Date.now();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

const hideLoader = () => {
  const elapsed = Date.now() - startTime;
  const remaining = Math.max(0, MIN_LOADER_TIME - elapsed);

  setTimeout(() => {
    const loader = document.getElementById("preloader");
    const root = document.getElementById("root");

    if (loader) {
      loader.classList.add("fade-out");
      setTimeout(() => loader.remove(), 400);
    }

    if (root) root.style.display = "block";
  }, remaining);
};

hideLoader();

